module.exports = __webpack_public_path__ + "img/comp-rulang.e8eb3b20.svg";